var render, staticRenderFns
import script from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedLikes.vue?vue&type=style&index=0&id=45cd7a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd7a4e",
  null
  
)

export default component.exports